export default "__VITE_ASSET__N2y6ciQQ__"